import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_USER_PROFILE_MISMATCH_STATUS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetMismatchStatusResult } from '../types/getMismatchStatus.types';

export const getMismatchStatus = (builder: BuilderType) =>
  builder.query<GetMismatchStatusResult, void>({
    query: () => ({
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: GET_USER_PROFILE_MISMATCH_STATUS_URL,
    }),
    keepUnusedDataFor: 0,
    transformResponse: (response: GenericApiResponse<GetMismatchStatusResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
